import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { InputComponent } from "../InputComponent";
import { TablaDinamica } from "../TablaDinamica";
import * as generic from "../Generico";
import { useLazyParams } from "../../hooks/useLazyParams";
import { Credito } from "../../models/trust/empleado/Credito";
import { CreditoCobrarService } from "../../service/trust/empleado/CreditoCobrarService";

export const CreditoCobrar = ({ toast, id, catalogos, permss, soloLectura }) => {

    const omodel = new Credito();
    const defaultValues = generic.funDefault(omodel.model, null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const [esOtraGarantia, setEsOtraGarantia] = useState(false);
    const menuRef = useRef(null);

    const creditoSrv = new CreditoCobrarService();
    const tablaCredito = useLazyParams({ modelo: omodel.model });

    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const { inText, inDrop, inNumber } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyData();
        // eslint-disable-next-line
    }, [tablaCredito.lazyParams, id]);

    const loadLazyData = () => {
        tablaCredito.setLoading(true);
        const _params = { ...tablaCredito.lazyParams, idp: id };
        creditoSrv.getLista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaCredito.setTotalRecords(res.data.total);
            tablaCredito.setData(res.data.registros);
        }).finally(() => tablaCredito.setLoading(false));
    };

    const openNew = () => {
        reset(defaultValues);
        setEsOtraGarantia(false);
        setDialogVisible(true);
    };

    const hideDialog = () => setDialogVisible(false);

    const onSubmit = (data) => {
        data.idp = id;
        data.otro = catalogos?.otra_garantia;

        const request = getValues('id') == null
            ? creditoSrv.nuevo(data)
            : creditoSrv.editar(data);

        request.then(res => {
            setDialogVisible(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => generic.funcErrorHibrida(error, toast, setError));
    };

    const editRegistro = (idReg) => {
        creditoSrv.consultar(idReg).then(res => {
            const _data = res.data.credito_cobrar;
            setEsOtraGarantia(_data.tipo_garantia?.cat_id === catalogos?.otra_garantia?.cat_id);
            reset(generic.renewValues(_data, omodel.model));
            setDialogVisible(true);
        });
    };

    const confirmDelete = (idReg) => {
        confirmDialog({
            message: '¿Está seguro de eliminar este crédito por cobrar?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                creditoSrv.eliminar(idReg).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const onChangeTipoGarantia = (e) => {
        setEsOtraGarantia(e.value?.cat_id === catalogos?.otra_garantia?.cat_id);
        setValue('otra_garantia', '');
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editRegistro(registroSeleccionado?.id) }]
            }];
        }
        return [{
            label: 'Opciones',
            items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editRegistro(registroSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu_credito" aria-haspopup onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }} />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Créditos por Cobrar
            </span>
        </div>
    );

    return (
        <div className="componente-credito-cobrar">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_credito" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaCredito} datos={tablaCredito.data} totalRegistros={tablaCredito.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogVisible} header={getValues('id') == null ? "Nuevo Crédito por Cobrar" : "Editar Crédito por Cobrar"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '660px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid px-2">

                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-file-edit text-primary"></i>
                                    CRÉDITO POR COBRAR
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {inDrop('tipo_identificacion', catalogos?.tipo_identificacion, { lab: omodel.optionLabel }, 6)}
                        {inText('identificacion', { icon: 'pi pi-id-card' }, 6)}
                        {inText('nombre_razon', { icon: 'pi pi-user' }, 12)}
                        {inDrop('tipo_garantia', catalogos?.tipo_garantia, { lab: omodel.optionLabel, chn: onChangeTipoGarantia }, esOtraGarantia ? 4 : 6)}
                        {esOtraGarantia && inText('otra_garantia', { icon: 'pi pi-pencil' }, 4)}
                        {inNumber('valor', 2, false, { prefix: '$ ' }, esOtraGarantia ? 4 : 6)}

                        <div className="col-12 mt-4 pt-3 flex justify-content-end border-top-1 border-300">
                            {soloLectura ? (
                                <div className="field col-auto p-0 m-0">
                                    <Button label="Cerrar" style={{ width: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>

                    </div>
                </form>
            </Dialog>
        </div>
    );
};
